module.exports = __webpack_public_path__ + "static/media/child.f73a98da.jpg";